import React, { useState } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { accSoftwareTab, syncBtn } from "../../../../locales/en";
import AccountingSoftConnectedModal from "../../../modals/AccountingSoftConnectedModal";

export const ManualInvoicesToggleButton = ({ toggleManualModal }) => {
  return (
    <div className="sync-btn">
      <button className="btn btn-primary" onClick={toggleManualModal}>
        {syncBtn.buttonLabel}
      </button>
    </div>
  );
};

ManualInvoicesToggleButton.propTypes = {
  toggleManualModal: PropTypes.func.isRequired
};

export const SyncInvoicesButton = ({
  handleSyncInvoices,
  xeroInvoiceJobId,
  showLoadingButton
}) => {
  return (
    <div className="sync-btn">
      {xeroInvoiceJobId !== null && xeroInvoiceJobId !== undefined ? (
        <button
          disabled
          className="btn btn-primary"
          onClick={handleSyncInvoices}
        >
          <div className="spinner-border custom-spinner-color" />
          {syncBtn.syncingLabel}
        </button>
      ) : (
        <button
          disabled={showLoadingButton}
          className="btn btn-primary"
          onClick={handleSyncInvoices}
        >
          {showLoadingButton && (
            <div className="spinner-border custom-spinner-color" />
          )}
          {syncBtn.defaultLabel}
        </button>
      )}
    </div>
  );
};

SyncInvoicesButton.propTypes = {
  handleSyncInvoices: PropTypes.func.isRequired,
  xeroInvoiceJobId: PropTypes.string,
  showLoadingButton: PropTypes.bool
};

export const LinkedAccountingSoftwareButton = () => {
  const [connectedSoftwareModal, setConnectedSoftwareModal] = useState(false);
  const handleConnectedSoftwareToggle = () => {
    setConnectedSoftwareModal(!connectedSoftwareModal);
  };
  return (
    <>
      <div className="link-btn">
        <Link
          to="#"
          className="btn btn-primary"
          state={{ linkToSoftwareBtn: true }}
          onClick={handleConnectedSoftwareToggle}
        >
          {accSoftwareTab.linkToSoftware}
        </Link>
      </div>
      <AccountingSoftConnectedModal
        isOpen={connectedSoftwareModal}
        toggle={handleConnectedSoftwareToggle}
      />
    </>
  );
};
